import ChartKey from './ChartKey'
import './ChartLegend.scoped.scss'

const ChartLegend = ({ lines, setSeriesEnabled }) => {
  return (
    <div className="chart-legend">
      {
        lines.map((line, i) =>
          <ChartKey
            key={i}
            label={line.label}
            color={line.color}
            enabled={line.enabled}
            onChange={(value) => setSeriesEnabled(line.key, value)}
          />)
      }
    </div>
  )
}

export default ChartLegend
